function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.81348 13.167C8.98633 13.167 10.9375 11.2686 10.9375 8.50879V0.976562C10.9375 0.484375 10.6123 0.167969 10.1201 0.167969C9.61914 0.167969 9.31152 0.484375 9.31152 0.976562V8.37695C9.31152 10.3369 8.01953 11.6641 5.81348 11.6641C3.625 11.6641 2.32422 10.3369 2.32422 8.37695V0.976562C2.32422 0.484375 1.99902 0.167969 1.50684 0.167969C1.01465 0.167969 0.698242 0.484375 0.698242 0.976562V8.50879C0.698242 11.2686 2.6582 13.167 5.81348 13.167ZM1.2168 15.8652H10.4102C10.7002 15.8652 10.9375 15.6455 10.9375 15.3467C10.9375 15.0479 10.7002 14.8193 10.4102 14.8193H1.2168C0.944336 14.8193 0.698242 15.0479 0.698242 15.3467C0.698242 15.6455 0.944336 15.8652 1.2168 15.8652Z",
  fill: "#B2B2BF"
});

function SvgIconUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnderline);
export default __webpack_public_path__ + "static/media/icon-underline.29a83107.svg";
export { ForwardRef as ReactComponent };